import '@backstage/cli/asset-types';

import ReactDOM from 'react-dom/client';
import App from './App';
import '@backstage/canon/css/styles.css';

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
